import React, { FC } from 'react'
import { InputSelect } from '../../../../components/input/select';
import { IInputProps } from '../../../../modules/form';


interface IInputSelect extends IInputProps {
  onStartTimeSelect?: any,
  onEndTimeSelect?: any,
  startTime?: string
  endTime?: string
  startOptions: any[]
  endOptions: any[]
}

export const TimeRangeSelect: FC<IInputSelect> = (props) => {
  const { onStartTimeSelect, onEndTimeSelect, startTime, endTime, startOptions, endOptions } = props;

  return (
    <div className="d-flex align-items-center">
      <div className="time-range-select">
        <InputSelect
          onChange={onStartTimeSelect}
          options={startOptions}
          value={startTime}
          isClearable={false}
          onTouched={() => false}
          name={'start'}
        />
      </div>
      <span className="px-2">{'đến'}</span>
      <div className="time-range-select">
        <InputSelect
          onChange={onEndTimeSelect}
          options={endOptions}
          value={endTime}
          isClearable={false}
          onTouched={() => false}
          name={'end'}
        />
      </div>
    </div>

  )
}